<template>
  <template v-if="audioUnavailable">
    <BError
      :error-title="$t('general.error')"
      :error-info="$t('transcription.audioUnavailable')"
    />
  </template>
  <template v-else>
    <div
      v-loading="audioUrl == null"
      :element-loading-text="$t('transcription.loading')"
      class="audio-player"
    >
      <audio
        ref="audio"
        class="audio"
        controls
        :src="audioUrl"
      />
      <div
        v-loading="transcriptionInProgress"
        :element-loading-text="$t('transcription.loading')"
      >
        <AudioWaveform
          v-if="audioUrl != null && transcriptionExists"
          ref="audio-waveform"
          class="audio-waveform"
          :transcription="transcription"
          :audio-url="audioUrl"
          :audio-ref="audio"
          :canvas-width="canvasWidth()"
          :canvas-height="20"
          @click:play-at="playAudio"
        />
      </div>
    </div>
  </template>
</template>

<script lang="ts" setup>
import { ref, DeepReadonly } from 'vue';
import { Transcription } from '@/api/openapi';
import AudioWaveform from '@/components/organisms/va-app/transcription/AudioWaveform.vue';

type Props = {
  transcription: DeepReadonly<Transcription> | null;
  transcriptionExists: boolean;
  transcriptionInProgress: boolean;
  audioUrl: string | undefined;
  audioUnavailable: boolean;
};
defineProps<Props>();

const audio = ref<HTMLAudioElement>();

const canvasWidth = () => {
  return audio.value?.clientWidth || 0;
};

const playAudio = (time: number) => {
  if (!audio.value) return;
  audio.value.currentTime = time;
  audio.value.play();
};

// 親コンポーネントから直接playAudioを呼び出せるようにする
defineExpose({ playAudio });
</script>

<style lang="scss" scoped>
.audio-player {
  display: block;
  background-color: rgba($uranus, 0.2);
  overflow: hidden;
  flex: 0 0 auto;
}

.audio {
  width: calc(100% - $basespace-500 * 2);
  margin: $basespace-500;
}

.audio-waveform {
  margin-left: $basespace-500;
  margin-right: $basespace-500;
}
</style>
